import lodashCloneDeep from "lodash/cloneDeep";

import {
  GET_MODAL,
  GET_NOTIFICATION,
  GET_NEW_NOTIFICATION,
} from "./actions.type";
import { SET_MODAL, SET_NOTIFICATION } from "./mutations.type";
import { DEFAULT_NOTIFICATION } from "@/common/constants/notifications";

const STATE = {
  modal: {
    visible: false,
    type: null, // saved-search, evacuation, hotspot, risk-rating, pulse, asset
    readOnly: false,
    commsOnly: false,
  },
  notification: lodashCloneDeep(DEFAULT_NOTIFICATION),
};

const GETTERS = {
  modal: (state) => state.modal,
  notification: (state) => state.notification,
};

const ACTIONS = {
  [GET_MODAL](context, data) {
    context.commit(SET_MODAL, data);
  },
  [GET_NEW_NOTIFICATION](context) {
    return new Promise((resolve, reject) => {
      const notification = lodashCloneDeep(DEFAULT_NOTIFICATION);
      context.commit(SET_NOTIFICATION, notification);
      resolve();
    });
  },
  [GET_NOTIFICATION](context, data) {
    return new Promise((resolve, reject) => {
      context.commit(SET_NOTIFICATION, data);
      resolve();
    });
  },
};

const MUTATIONS = {
  [SET_MODAL](state, data) {
    state.modal = data;
  },
  [SET_NOTIFICATION](state, data) {
    state.notification = data;
  },
};

export default {
  namespaced: true,
  state: STATE,
  actions: ACTIONS,
  mutations: MUTATIONS,
  getters: GETTERS,
};
